<script setup lang="ts">
const supports = [
  'Memiliki learning ecosystem yang dibangun untuk meningkatkan kualitas bisnis member',
  'Dapat dihubungi di platform mana pun, via Telepon, WhatsApp, atau Media Sosial.'
]
</script>

<template>
  <div class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionWrapper
      title="Selalu Siap Membantu Bisnis Kamu"
      title-as="h2"
      class="bg-transparent dark:bg-transparent"
      description="KiriminAja membantu permasalahan bisnismu, dari pengiriman paket hingga pengembangan bisnis."
      hero-image="/assets/home-v4/support.webp"
    >
      <template #action>
        <div class="mt-6 lg:mt-12 flex flex-col gap-6 text-lg leading-7">
          <div
            v-for="(support, index) in supports"
            :key="index"
            class="flex gap-2"
          >
            <Icon
              class="text-primary flex-none"
              name="material-symbols:verified"
              size="24px"
            />
            <p class="text-sm lg:text-lg flex-1">
              {{ support }}
            </p>
          </div>
        </div>
      </template>
    </UiSectionWrapper>
  </div>
</template>
